import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../CommonComponents/BreadCrumb.tsx";
import BannerComponent from "../BannerComponent.tsx";
import backgroundImg from "../../../../assets/images/eic-bg.png";
import logo from "../../../../assets/images/aptechEICNew.png";
import SectionComponent from "../SectionComponent.tsx";
import styles from "./EIC.module.scss";
import empoweringImg from "../../../../assets/images/eic-empowering-img.png";
import empowerMobileImg from "../../../../assets/images/eic-empowering-mobile-img.png";
import { Icon } from "../../../../assets/Icons.tsx";

const EIC: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const breadcrumb = [
    { title: "Our Businesses", link: "/our-businesses" },
    {
      title: "Institutional Business",
      link: "/our-businesses/institutional-business/",
    },
    { title: "Education Institutes and Corporates (EIC)", link: "" },
  ];
  const capabilities = [
    {
      title: "Finance:",
      icon: "eicFinanceIcon",
      des: "CPA, CMA, ACCA, CFA",
    },
    {
      title: "Technology:",
      icon: "eicTechnologyIcon",
      des: "CEH, Data Science, Cloud & DevOps",
    },
    {
      title: "Business:",
      icon: "eicBusinessIcon",
      des: "Digital Marketing, Project Management, Business Analytics",
    },
    {
      title: "Creative Fields:",
      icon: "eicCreativeIcon",
      des: "Animation, VFX, UI/UX Design, Visual Storytelling",
    },
  ];

  const bridgingGap = [
    "<strong>School-to-college</strong> transitions with foundational skills",
    "College-to-career pathways with <strong> NEP-aligned, domain-specific learning</strong>",
    "<strong>Campus-to-corporate readiness</strong> with soft skills and job simulation programs",
    "<strong>Faculty development</strong> & <strong>administrative training</strong> for institutional excellence",
    "Internship & placement assistance via our <strong>ICAP</strong> (Industry Connect and Placement).",
  ];

  const enablingBusiness = [
    "<strong>Emerging technologies:</strong> GenAI, Cybersecurity, Data Analytics, SaaS Tools",
    "<strong>Behavioral & leadership skills:</strong> Critical thinking, change management, decision-making",
    "<strong>Functional expertise:</strong> Finance for non-finance, marketing strategy, HR effectiveness",
    "<strong>Workplace readiness:</strong> Communication, collaboration, compliance & ethics",
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className="container mt-5 mb-5 d-flex flex-column gap-5">
        <BannerComponent
          bg={backgroundImg}
          title1="Education Institutes and Corporates (EIC)"
          title2="Creating Talent That’s Trained, Future-Ready & Industry-Aligned"
        />
        <div className="d-flex flex-column flex-md-row gap-4 align-items-start">
          <div className="d-none d-md-block">
            <img src={logo} alt="course logo" />
          </div>
          <div className="d-flex flex-column" style={{ gap: 25 }}>
            <p>
              With a legacy of over 39 years, a presence in 40+ countries, and
              over 7.5 million learners trained, Aptech is now reaching beyond
              its retail education model through EIC (Education Institutions &
              Corporates)—a focused vertical created to address the growing
              demand for skilling, upskilling, and reskilling in today's
              education and employment landscape.
            </p>
            <p>
              <strong>Empowering Learning, Anywhere</strong>
            </p>
            <p>
              Aptech EIC partners directly with K–12 schools, colleges,
              universities, ITIs, and polytechnics, as well as corporates of all
              sizes, to deliver instructor-led, job-focused training
              programs—on-campus or online. Our aim is to meet learners at their
              doorstep and ensure they are prepared not just for jobs, but for
              long-term career success.
            </p>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row md:align-items-center">
          <div style={{ width: isMobile ? "100%" : "50%" }} className="">
            <p style={{ fontWeight: 700 }} className="para">
              Bridging the Gap Between Education & Employability
            </p>
            <div className="d-flex flex-column gap-3">
              {bridgingGap.map((i, index) => (
                <div
                  key={index}
                  className="d-flex flex-row align-items-center gap-2"
                >
                  <Icon name="squareBlockIcon" />

                  <p
                    className="mb-0"
                    dangerouslySetInnerHTML={{ __html: i }}
                  ></p>
                </div>
              ))}
            </div>
          </div>
          <div
            style={{ width: isMobile ? "100%" : "50%" }}
            className="mt-5 mt-md-0"
          >
            <p style={{ fontWeight: 700 }} className="para">
              Enabling Business Success Through Capability Building
            </p>
            <p>
              For corporates, Aptech EIC provides customized, instructor-led
              training based on role, function, and performance gaps. Programs
              are offered across:
            </p>
            <div className="d-flex flex-column gap-3">
              {enablingBusiness.map((i, index) => (
                <div
                  key={index}
                  className="d-flex flex-row align-items-center gap-2"
                >
                  <Icon name="squareBlockIcon" />

                  <p
                    className="mb-0"
                    dangerouslySetInnerHTML={{ __html: i }}
                  ></p>
                </div>
              ))}
            </div>
            <p className="mt-3">
              All programs are designed to improve productivity, retention, and
              performance across departments and hierarchies.
            </p>
          </div>
        </div>

        <div
          style={{
            padding: isMobile ? "10px" : "15px 30px",
            background: "#EDE6DA",
            borderRadius: "16px",
            boxSizing: "border-box",
          }}
        >
          <div className="d-flex flex-column flex-md-row justify-content-start align-items-start md:justify-content-between md:align-items-center gap-1 gap-md-5">
            <img
              src={isMobile ? empowerMobileImg : empoweringImg}
              style={{ borderRadius: "16px", width: "100%" }}
            />
            <div className="md:flex-1">
              <p className="heading3">Empowering Learning, Anywhere</p>
              <p>
                Aptech EIC partners directly with{" "}
                <strong> K–12 schools, colleges, universities, ITIs,</strong>{" "}
                and <strong>polytechnics</strong>, as well as corporates of all
                sizes, to deliver instructor-led, job-focused training
                programs—on-campus or online. Our aim is to meet learners at
                their doorstep and ensure they are prepared not just for jobs,
                but for long-term career success.
              </p>
            </div>
          </div>
        </div>

        <div>
          <p className="text-center heading3 mb-0">
            National & Global Certifications
          </p>
          <p className="para text-center">
            We also offer globally recognized certifications in:
          </p>
          <div
            className="d-flex flex-column flex-md-row flex-wrap"
            style={{ gap: "10px" }}
          >
            {capabilities.map((c, index) => (
              <div key={index} className={styles.capabilitiesCont}>
                <Icon name={c.icon} />
                <p
                  style={{ color: "#DB6516", fontWeight: 600 }}
                  className="para mb-0"
                >
                  {c.title}
                </p>
                <p>{c.des}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="d-flex flex-row justify-content-center">
          <div className="txtDiv">
            <p style={{ textAlign: "center" }} className="heading3">
              Strategic Collaborations for Scalable Impact
            </p>
            <p style={{ textAlign: "center" }} className="para">
              Aptech collaborates with academic councils, industry bodies, and
              enterprise L&D leaders to design scalable, relevant programs that
              match sectoral skill demand. Whether it’s an institutional tie-up,
              a corporate L&D intervention, or a national training mandate, we
              bring the agility, credibility, and infrastructure to deliver at
              scale.
            </p>
          </div>
        </div>

        <div>
          <div className="d-flex flex-column align-items-center">
            <p
              style={{ color: "#DB6516" }}
              className="text-center heading3 mb-0"
            >
              Our Esteemed Clients
            </p>
            <p className="para">
              We're proud to have trained talent across sectors including
              automotive, BFSI, telecom, retail, education, manufacturing, and
              services.
            </p>
          </div>

          <div className="d-flex flex-row justify-content-center">
            <div className={styles.scrollContainer}>
              <div className={styles.scrollDiv}>
                {[
                  "UNICEF",
                  "National Informatics Centre Services Inc",
                  "DDUGKY",
                  "Skill Council for Green Jobs",
                  "Centre for Railway Information Systems",
                  "NSDC",
                  "Life Insurance Corporation of India",
                  "Construction Skill Development Council of India",
                  "Department of Information Technology & Communication",
                  "NALCO",
                  "Naval Dockyard",
                  "WBSEDCL",
                  "Life Insurance Corporation of India (LIC)",
                  " Aditya Birla Fashion & Retail",
                  "The Royal Bank of Scotland (RBS)",
                  "The New India Assurance Co. Ltd.",
                  "The Oriental Insurance Company Limited",
                  "United India Insurance Company Limited",
                  "HP",
                  "ITC Limited",
                  "Swiss Re",
                  "Flipkart",
                ]
                  .concat([
                    "UNICEF",
                    "National Informatics Centre Services Inc",
                    "DDUGKY",
                    "Skill Council for Green Jobs",
                    "Centre for Railway Information Systems",
                    "NSDC",
                    "Life Insurance Corporation of India",
                    "Construction Skill Development Council of India",
                    "Department of Information Technology & Communication",
                    "NALCO",
                    "Naval Dockyard",
                    "WBSEDCL",
                    "Life Insurance Corporation of India (LIC)",
                    " Aditya Birla Fashion & Retail",
                    "The Royal Bank of Scotland (RBS)",
                    "The New India Assurance Co. Ltd.",
                    "The Oriental Insurance Company Limited",
                    "United India Insurance Company Limited",
                    "HP",
                    "ITC Limited",
                    "Swiss Re",
                    "Flipkart",
                  ])
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`${styles.scrollItem} cardHeading`}
                    >
                      {item}
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-center">
            <div className={styles.scrollContainer}>
              <div className={styles.scrollDiv}>
                {[
                  "CFA (Chartered Financial Analyst)",
                  "CPA (Certified Public Accountant)",
                  "Association of Chartered Certified Accountants",
                  "FRM (Financial Risk Manager)",
                  "CMA (Certified Management Accountant)",
                  "GST Practitioner Certification",
                  "Certified Financial Planner (CFP)",
                  "CISSP (Certified Information Systems Security Professional)",
                  "CISA (Certified Information Systems Auditor)",
                  "CEH (Certified Ethical Hacker)",
                  "CCSP (Certified Cloud Security Professional)",
                  "Business Analytics Certification",
                ]
                  .concat([
                    "CFA (Chartered Financial Analyst)",
                    "CPA (Certified Public Accountant)",
                    "Association of Chartered Certified Accountants",
                    "FRM (Financial Risk Manager)",
                    "CMA (Certified Management Accountant)",
                    "GST Practitioner Certification",
                    "Certified Financial Planner (CFP)",
                    "CISSP (Certified Information Systems Security Professional)",
                    "CISA (Certified Information Systems Auditor)",
                    "CEH (Certified Ethical Hacker)",
                    "CCSP (Certified Cloud Security Professional)",
                    "Business Analytics Certification",
                  ])
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`${styles.scrollItem} cardHeading`}
                    >
                      {item}
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-center">
            <div className={styles.scrollContainer}>
              <div className={styles.scrollDiv}>
                {[
                  "ActionCOACH",
                  "Brian Tracy Solutions",
                  "Sales Geek",
                  "Basketball Training Systems (BTS)",
                  "Engage & Grow",
                  "NLP4Kids",
                  "District 32",
                  "AWS",
                  "GrevX Academy",
                ]
                  .concat([
                    "ActionCOACH",
                    "Brian Tracy Solutions",
                    "Sales Geek",
                    "Basketball Training Systems (BTS)",
                    "Engage & Grow",
                    "NLP4Kids",
                    "District 32",
                    "AWS",
                    "GrevX Academy",
                  ])
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`${styles.scrollItem} cardHeading`}
                    >
                      {item}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        <SectionComponent
          desc="For partnerships, campus programs, or corporate training solutions, write to us at:"
          title="<p><strong>Aptech EIC</strong> - Skilling that Starts with Purpose and Ends with Performance.</p>"
        />
      </div>
    </>
  );
};

export default EIC;
